import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { FormNumberInput } from "../../common/form-fields-wrappers";
import { IExpiredThresholdForm } from "../../models/models";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

interface ThresholdProps {
    title: "tolleranceThreshold" | "firstSMSThreshold" | "recoveryCompanyThreshold" | "warningLetterThreshold" | "complaintThreshold" 
}

const Threshold = ({
    title
}: ThresholdProps) => {

    const {t} = useTranslation(['expiredManagement']);

    return (
        <Box pt={1} pb={1}>
            <Grid container spacing={2} >
                <Grid item xs={12} >
                    <Typography variant={'h5'} fontWeight={"bold"} color={"primary"}>{t(`expiredConfiguration.form.${title}`)}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormNumberInput<IExpiredThresholdForm> 
                        name={`${title}.shortTerm`}
                        label={t('expiredConfiguration.form.shortTerm')}
                        minValue={0}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormNumberInput<IExpiredThresholdForm> 
                        name={`${title}.subscription`}
                        label={t('expiredConfiguration.form.subscription')}
                        minValue={0}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormNumberInput<IExpiredThresholdForm> 
                        name={`${title}.corporate`}
                        label={t('expiredConfiguration.form.corporate')}
                        minValue={0}
                    />
                </Grid>

                <Grid item sm={6} lg={9} />

            </Grid>
        </Box>
    )
}

export default Threshold;